<template>
  <div>
    <label class="text-left block">
      <slot></slot>
    </label>
    <Input
      class="w-full rounded-md !shadow w-full border-gray-300"
      type="time"
      :step="60"
      :required="required"
      :disabled="disabled"
      v-model="formValues"
    />
  </div>
</template>

<script>

import Input from '../Input.vue'

export default {
  components: {
    Input,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: undefined,
    defaultValue: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      formValues: undefined,
    }
  },
  mounted() {
    this.formValues = this.defaultValue
  },
  methods: {
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    }
  }
}
</script>
